import styled, { keyframes } from 'styled-components'
import { Collapse as CollapseComponent } from 'ui'

const fadeIn = keyframes`
    0% { opacity : 0; }
    100% { opacity: 1; }
`

export const Collapse = styled(CollapseComponent)`
    animation: ${fadeIn} 0.15s ease-out;
`

export const Row = styled.div`
    display: flex;
`
